.footer {
  border-top: 1px solid var(--border);
  background: var(--bg-inset);
  padding-block: clamp(2.5rem, 5vw, 4rem);
}

.inner {
  display: grid;
  gap: 1.75rem;
}

.name {
  font-family: var(--font-display);
  font-size: var(--step-2);
  letter-spacing: -0.01em;
}

.meta {
  margin-top: 0.2rem;
  color: var(--text-faint);
  font-size: var(--step--1);
}

.links ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
}

.links a {
  color: var(--text-dim);
  font-size: var(--step--1);
  text-decoration: none;
}

.links a:hover {
  color: var(--accent);
  text-decoration: underline;
}

.bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border);
}

.copyright {
  color: var(--text-faint);
  font-size: 0.8rem;
}

.top {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: var(--text-dim);
  font-size: 0.8rem;
  text-decoration: none;
}

.top:hover {
  color: var(--accent);
}
